import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import Collapsible from 'react-collapsible';
import { BottomNavigation, BottomMenu } from '../menu/index';

import {
    MenuItemOverview,
    MenuItemInvoices,
    HamburgerMenuBottom,
    SubMenuItemCustomerSupport,
    SubMenuItemCustomerProfile,
    SubMenuItemLogout,
    matchURLs,
} from './Links';

import './MobileNavigation.scss';
import Overlay from './Overlay';

const MobileNavigation = ({ hasZeroAccounts, hasInvoiceNotification }) => {
    const [showSubMenu, setShowSubMenu] = useState(false);

    const toggleSubMenu = () => {
        setShowSubMenu(!showSubMenu);
    };

    const renderSE = () => {
        const urls = matchURLs();
        // const urls = matchURLs(window.location.hash);

        return (
            <>
                <Overlay onClick={toggleSubMenu} show={showSubMenu} />
                <BottomNavigation>
                    <Collapsible
                        open={showSubMenu}
                        trigger={null}
                        contentHiddenWhenClosed
                        lazyRender
                        transitionTime={200}
                    >
                        {!hasZeroAccounts && <SubMenuItemCustomerProfile isActive={urls.customerProfileIsActive} />}
                        <SubMenuItemCustomerSupport isActive={urls.customerSupportIsActive} />
                        <SubMenuItemLogout />
                    </Collapsible>
                    <BottomMenu>
                        <MenuItemOverview isActive={urls.overviewIsActive} />
                        <MenuItemInvoices isActive={urls.invoiceIsActive} hasNotification={hasInvoiceNotification} />
                        <HamburgerMenuBottom toggleSubMenu={toggleSubMenu} />
                    </BottomMenu>
                </BottomNavigation>
            </>
        );
    };

    return renderSE();
};

export default withRouter(MobileNavigation);
